export default "__VITE_ASSET__DNgg$iBk__"